/**
* Copyright by: 

* by ESS-Ehrhardt Software Solutions & Service GmbH
* Basselscheider Str. 55
* D-56281 Emmelshausen
* +49 (0) 67 42 / 87 27 0
* info@epg.com
*/
import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { faPlus, faSearch } from '@fortawesome/pro-regular-svg-icons';
import { Subscription } from 'rxjs';
import { OneAppPermission } from '../../../enums/permission.enum';
import { EmployeeGroupModel } from '../../../models/employee-group.model';
import { EmployeeService } from '../../../services/employee.service';

@Component({
  selector: 'app-employee-group',
  templateUrl: './employee-group.component.html',
  styleUrls: ['./employee-group.component.scss'],
  standalone: false
})
export class EmployeeGroupComponent implements OnInit, OnDestroy {
  empGroupChangedSubscription = new Subscription();

  faSearch = faSearch;
  faPlus = faPlus;

  employeeGroups: EmployeeGroupModel[] = [];
  searchText: string = '';
  OneAppPermission = OneAppPermission;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private employeeService: EmployeeService
  ) {}

  async ngOnInit(): Promise<void> {
    this.employeeGroups = await this.employeeService.getEmployeeGroups();
    this.empGroupChangedSubscription = this.employeeService.employeeGroupsChanged.subscribe(
      (empGroups) => {
        this.employeeGroups = empGroups;
      }
    );
  }

  ngOnDestroy(): void {
    this.empGroupChangedSubscription.unsubscribe();
  }
  onNewEmployeeGroupClick() {
    this.router.navigate(['new'], { relativeTo: this.route });
  }
}
